import { secondsToMilliseconds } from "date-fns";
import {
  doPendingWork,
  AlreadyInProgressError,
} from "../api/status/doPendingWork";
import { getPendingWork } from "../api/status/getPendingWork";
import { captureRequestError } from "../helper/captureRequestError";
import {
  refreshGroupList,
  invalidateTransactionQueryCache,
} from "./actions/groupList";
import { useTransactionsStore } from "./transactionsStore";

export async function checkStatusAndDoPendingWork() {
  const pendingWorkResponse = await getPendingWork();
  const previouslyUpdating = useTransactionsStore.getState().updating;
  const updating =
    pendingWorkResponse.processing || pendingWorkResponse.updateFrom != null;

  useTransactionsStore.setState({
    updating,
  });

  // refresh view once we have settled
  if (previouslyUpdating && !updating) {
    invalidateTransactionQueryCache();
    refreshGroupList();
  }

  if (pendingWorkResponse.processing || !pendingWorkResponse.updateFrom) return; // nothing to do

  try {
    await doPendingWork();

    // update status and do any subsequent work
    checkStatusAndDoPendingWork();
  } catch (error) {
    if (error instanceof AlreadyInProgressError)
      useTransactionsStore.setState({
        updating: true,
      });
    else {
      captureRequestError(error);
    }
  }
}
let statusUpdateTimer;

export function pollPendingWork() {
  if (statusUpdateTimer) return;
  statusUpdateTimer = setInterval(
    checkStatusAndDoPendingWork,
    secondsToMilliseconds(10)
  );
  checkStatusAndDoPendingWork();
}

export function stopPollingPendingWork() {
  if (statusUpdateTimer) {
    clearInterval(statusUpdateTimer);
    statusUpdateTimer = null;
  }
}
